import { render, staticRenderFns } from "./EndorsementCertificate.vue?vue&type=template&id=83413110&"
import script from "./EndorsementCertificate.vue?vue&type=script&lang=js&"
export * from "./EndorsementCertificate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports